module.exports = __webpack_public_path__ + "static/media/home1.d033bec2.png";